<template>
    <div class="d-flex align-items-center justify-content-center">
        <b-button v-if="params.data.component !== 'verification'" variant="default" @click="$bvModal.show(modalId)">
            <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
        <modal
            :id="modalId"
            title="Remove Module Subscription
"
            @ok="removeModule"
        >
            Are you sure you want to remove this module?
        </modal>
    </div>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';
export default {
    components: {
        Modal,
    },
    computed: {
        modalId() {
            return this.params && 'remove-module' + this.params.data.id;
        },
    },
    methods: {
        removeModule() {
            this.params.removeModule && this.params.removeModule(this.params.data.id);
        },
    },
};
</script>

<style>
</style>